import { Button } from "@/components/ui/button";
import { formatPitchDate } from "@/lib/phase";

const ZOOM_FALLBACK = "https://us02web.zoom.us/j/4973874078?pwd=emZkMHlvR1YvbUF2d3FQNWZQblhwdz09";

/**
 * "Tonight's Lineup" — appears only on the three pitch nights (June 16/17/18, ET).
 * Shows that evening's honorees in a single banner directly under the hero,
 * with a "Join Zoom" CTA.
 */
export default function TonightsLineup({ businesses, zoomUrl }) {
  const todayISO = new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" });
  const PITCH_DAYS = ["2026-06-16", "2026-06-17", "2026-06-18"];
  if (!PITCH_DAYS.includes(todayISO)) return null;

  const list = (businesses || [])
    .filter((b) => b.pitch_day === todayISO && (b.schedule_status || "Confirmed") === "Confirmed")
    .sort((a, b) => (a.interview_time || "").localeCompare(b.interview_time || ""));

  if (list.length === 0) return null;

  const join = list[0]?.livestream_url || zoomUrl || ZOOM_FALLBACK;

  return (
    <section data-testid="tonights-lineup" className="bg-amber-300 text-emerald-950 py-8 border-b-4 border-emerald-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="lg:w-1/3">
            <div className="text-[11px] uppercase tracking-[0.3em] font-[Outfit] font-bold text-rose-700 flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-rose-600 animate-pulse" />
              Tonight's Lineup
            </div>
            <h3 className="font-[Cormorant_Garamond] text-3xl sm:text-4xl mt-1 leading-tight">
              {formatPitchDate(todayISO)}
            </h3>
            <p className="font-[Outfit] text-sm text-emerald-900 mt-2">
              {list.length} honoree{list.length === 1 ? "" : "s"} interviewing live on Zoom tonight.
            </p>
            <Button asChild data-testid="tonights-join-btn" className="rounded-full bg-emerald-950 hover:bg-emerald-900 text-white font-[Outfit] font-semibold h-11 px-6 mt-4">
              <a href={join} target="_blank" rel="noreferrer">▶ Join Zoom</a>
            </Button>
          </div>
          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 flex-1">
            {list.map((b) => (
              <li key={b.id} data-testid={`lineup-${b.id}`} className="bg-emerald-950 text-white rounded-lg p-4 flex flex-col gap-1">
                <div className="text-[10px] uppercase tracking-[0.25em] font-[Outfit] font-bold text-amber-300">
                  {b.interview_time}
                </div>
                <div className="font-[Cormorant_Garamond] text-xl leading-tight">{b.name}</div>
                {b.business_name && (
                  <div className="font-[Outfit] text-xs text-emerald-100">{b.business_name}</div>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
